const SexeOptions = [
  {label: "Homme", value: "H"},
  {label: "Femme", value: "F"},
];

export default SexeOptions;